import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="url-type"
export default class extends Controller {
  static targets = ["newTab", "url"];
  static classes = ["disabled"];

  connect() {
    this.#perform();
  }

  update() {
    this.#perform();
  }

  #perform() {
    const isAnchor = this.urlTarget.value.startsWith("#");
    const checkbox = this.newTabTarget.querySelector('input')
    const label = this.newTabTarget

    if(isAnchor) {
      checkbox.checked = false;
    }

    checkbox.disabled = isAnchor

    const action = isAnchor ? "add" : "remove";
    label.classList[action](this.disabledClass)
  }
}
